/* eslint-disable no-underscore-dangle,func-style,no-template-curly-in-string */

import {typeOf, hasClass} from '@utils/linktools';

export default {
    props: {

        /* 配置信息*/
        conf: {
            type: Object,
            default() {
                return {};
            }
        },

        /* 安全性配置*/
        oauth: String,

        /* 主题*/
        theme: {
            type: String,
            default: ''
        },

        /* 块标题*/
        title: String,

        /* 参数变化时自动刷新列表*/
        autofresh: {
            type: Boolean,
            default: true
        },

        /* 新建/编辑/删除 时强制刷新列表*/
        optfresh: {
            type: Boolean,
            default: false
        },

        /* 当前行*/
        currentrow: {
            type: Object,
            default: null
        },

        /* 当前行id*/
        currentid: {
            type: String,
            default: null
        },

        /* 查询参数入口*/
        queryPara: Object,

        /* 新建参数入口*/
        insertPara: Object,

        /* 更新参数入口*/
        updatePara: Object,

        /* 新建/更新 参数入口*/
        upsertPara: Object,

        /* 设置主要行 参数入口*/
        upmainPara: Object,

        /* 主要行 关联id*/
        mainRelateid: String,

        /* 表格行数据*/
        data: {
            type: Array,
            default() {
                return [];
            }
        },

        /* 分页条数可选项*/
        pgSizes: {
            type: Array,
            default() {
                return [5, 20, 50, 100];
            }
        },

        /* 分页样式*/
        pagerLayout: String,

        /* 分页自动隐藏*/
        pagerAutohide: {
            type: Boolean,
            default() {
                return false;
            }
        },

        /* 是否禁用接口交互*/
        islocal: {
            type: Boolean,
            default: false
        },

        /* 禁用接口交互时，允许首次加载数据*/
        loadonce: {
            type: Boolean,
            default: false
        },

        /* 禁用接口交互时，是否禁用本地的筛选功能*/
        localFilter: {
            type: Boolean,
            default: true
        },

        /* 主要行的id*/
        mainid: {
            type: String,
            default: null
        },

        /* 表格的高度*/
        height: [String, Number],

		/*列表行的高度*/
		rowHeight: {type: [String, Number], default: 40},

		/*列表头的高度*/
		headerHeight: {type: [String, Number], default: 40},

        /* 是否启用自带工具栏*/
        toolsShow: {
            type: Boolean,
            default: true
        },

        /* 是否显示更多按钮*/
        buttonMore: {
            type: Boolean,
            default() {
                return true;
            }
        },
        /* 是否显示更多--导入按钮*/
        buttonImport: {
            type: Boolean,
            default() {
                return false;
            }
        },
        /* 是否显示更多--导出按钮*/
        buttonExport: {
            type: Boolean,
            default() {
                return true;
            }
        },

        /* 导入接口*/
        importUrl: String,

        /* 导出接口*/
        exportUrl: String,

        /* 是否启用分页栏*/
        pagerShow: {
            type: Boolean,
            default: true
        },

        /* 查询前钩子函数*/
        beforeQuery: Function,

        /* 查询后的钩子函数*/
        afterQuery: Function,

        /* 插入/更新前的钩子函数*/
        beforeUpsert: Function,

        /* 插入/更新后的钩子函数*/
        afterUpsert: Function,

        /* 更新主要行前的钩子函数*/
        beforeUpmain: Function,

        /* 打开编辑框前的钩子函数*/
        beforeEdit: Function,

        /* 删除前的钩子函数*/
        beforeDel: Function,

        /* 清空列表时的钩子函数（islocal为false时有效）*/
        beforeClear: Function,

        /* 自动监听编辑框 确定/取消 的click事件*/
        clickMonitor: {
            type: Boolean,
            default: false
        },

        /* 默认所有字段的排序*/
        sortAll: {
            type: Boolean,
            default: true
        },
        /* 头行结构，行关联头的字段*/
        parentField: String,
        /* 头行结构，头Id*/
        parentId: String,
        /* 是否根据分页条目的确定高度*/
        autoHeight: {
            type: Boolean,
            default(){
                return true;
            }
        },
        /*是否要显示in-duty这个类名的样式*/
        showduty: {
            type: Boolean,
            default: false // 默认显示 为true则不显示
        },
        /*是否要隐藏外围border*/
        hideFrameBorder: {
            type: Boolean,
            default: false // 默认显示 为true则不显示
        }
    },
    data() {

        return {
            /* 加载状态 */
            loading: false,

            /* 排序配置*/
            sortConf: {},

            /* 单字段查询条件*/
            searchFilter: null,

            /* 快速筛选查询条件*/
            quickFilter: [],

            /* 组合查询条件*/
            combFilter: [],

            /* 筛选组件的配置信息*/
            searchOptions: [],

            /* 上一个 queryPara 属性的值*/
            queryParaPre: '',

            /* lastParentId*/
            lastParentId: null,

            /* 是否已经加载过数据*/
            isLoadonceValid: true,

            /* 表格当前数据*/
            rows: [],

            /* 表格本地筛选*/
            rowsRef: [],
            rowsRefIndex: [],
            tableData: [],

            /* 当前页、总数、一页的条目数*/
            page: 1,
            total: 0,

            pageSize: this.fitHeight?this.defaultRows:this.pgSizes[0],

            /* 分页栏是否显示总数*/
            totalFlag: false,

            /* 主要行*/
            mainRow: {id: null},

            /* 删除弹框*/
            delRow: {},
            delIndex: -1,

            /* 编辑弹框*/
            editShow: false,
            editFmDt: {},
            editMode: false,
            editIndex: -1,
            isSaving: false,

            /* 导出配置弹框的显示*/
            exportShow: false,

            /* 组合查询弹框的显示*/
            combfilterShow: false,

            /* 清空列表弹框*/
            clearShow: false,
            lastQueryPara: {},

            /* 子组件引用*/
            editDialog: {},

            tools: {
                editCancel: {},
                editSubmit: {},
                showNew: {},
                showClear: {},
                showDel: {},
                showEdit: {},
                menuMore: {}
            },
            elTable: {},
            tablecols: [],

            /* 强制查询总数的标志*/
            forceTotalflag: false,

            /* 是否已强制查询到了总数*/
            isTotalForceFetched: false,

            /* 最佳适应条目数 */
            fitRows: null
        };
    },
    watch: {
        queryPara: {
            immediate: true,
            handler: function (val) {
                if (this.autofresh) {
                    var str = val && typeof val === 'object' ? JSON.stringify(val) : 'null';
                    if (str != this.queryParaPre) {
                        this.queryParaPre = str;
                        this.loadRows();
                    }
                }
            }
        },
        parentId: {
            immediate: true,
            handler: function (val) {
                if(this.lastParentId!==val){
                    this.lastParentId = val;
                    this.loadRows();
                }
            }
        },
        mainid(val) {
            var row = {id: val};
            this.submitPropmain(row, true);
        },
        data(val) {
            if(!Array.isArray(val)){
                val = [];
            }
            if (this.islocal) {
                this.setTbData(val);
            } else {
                this.rows = val;
            }
        }
    },
    computed: {
        defaultRows(){
            return this.pgSizes[0];
        },
        pagerSizes(){
            var pageSizes = this.pgSizes;
            pageSizes = linkTools.deepCopy(pageSizes);
            if(this.fitHeight && this.fitRows!==null && this.fitRows>this.defaultRows){
                pageSizes.sort((a, b) => a-b);
                if(this.fitRows!==null && pageSizes.indexOf(this.fitRows)<0){
                    for(var i=pageSizes.length-1; i>=0; i--){
                        if(this.fitRows>pageSizes[i]){
                            pageSizes.splice(i+1, 0, this.fitRows);
                            break;
                        }
                    }
                }
            }
            return pageSizes;
        },
        fields(){
            var cache = linkTools.deepCopy(this.searchOptions) || [];
            cache.forEach((field) => {
                if(field.lov){
                    field.options = linkLov.getLovArray(field.lov);
                }
            });
            return cache;
        },
        currentRow() {
            if (this.elTable && this.elTable._isVue) {
                return this.elTable.store.states.currentRow;
            }
            return null;
        },
        currentIndex() {
            var rslt = -1;
            if (this.elTable && this.elTable._isVue) {
                var row = this.elTable.store.states.currentRow;
                const rows = this.rows;
                const str = JSON.stringify(row);
                for (var i = 0; i < rows.length; i++) {
                    if (JSON.stringify(rows[i]) === str) {
                        rslt = i;
                        break;
                    }
                }
            }
            return rslt;
        },
        defaultHeight(){
            const scrollBarHeight = this.horizonScroll?this.scrollBarHeight:0;
            const headerHeight = this.tableHeaderHeight || 40;
            var result = this.rowHeight * 10 + headerHeight + scrollBarHeight;
            if(Array.isArray(this.pgSizes) && this.pgSizes.length){
                const size = this.pgSizes[0];
                if(typeOf(size) === 'number'){
                    result = size * this.rowHeight + headerHeight + scrollBarHeight;
                }
            }
            return result;
        },
        tableHeight(){
            if(!this.autoHeight){
                return undefined;
            }
            var result = this.defaultHeight;
            if(this.fitHeight){
                result = Math.max(this.tableFitHeight-1,0);
            }else if(this.height!=undefined){
                result = this.height;
            }
            return result;
        },
        tableProps(){
            return{
                data: this.rows,
                border: true,
                highlightCurrentRow: true,
                height: this.tableHeight,
                headerRowClassName: 'el-table-header-row',
				cellStyle: ()=>{
					return {
						lineHeight: `${this.rowHeight}px`,
						height: `${this.rowHeight}px`
					}
				},
				headerCellStyle: ()=>{
					return {
						lineHeight: `${this.headerHeight}px`,
						height: `${this.headerHeight}px`
					}
				}
            };
        }
    },
    created() {
        /* 监听下拉筛选事件*/
        this.$on('search-change', (val) => {
            if (val && typeof val === 'object') {
                this.searchFilter = val;
                this.combFilter = [];
                this.loadRows();
            }
        });
        /* 监听快速筛选事件*/
        this.$on('quickfilter-change', (val) => {
            if (Array.isArray(val)) {
                this.quickFilter = val;
                this.loadRows();
            }
        });
        /* 监听组合查询事件*/
        this.$on('combfilter-change', (val) => {
            if (Array.isArray(val)) {
                this.combFilter = val;
                this.loadRows();
            }
        });

        if(this.fitHeight){
            /* 监听表格调节事件 */
            this.$on('resized', () => {
                if(!this.isHeightFited){
                    this.getFitRows();
                    this.pageSize = this.defaultRows;
                    if(this.fitRows!==null && this.fitRows>this.defaultRows){
                        this.pageSize = this.fitRows;
                    }
                    this.isHeightFited = true;
                    this.loadRows();
                }
            });
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        /**
         * @method：getFitRows
         * @createdBy:HuangJian
         * @date:2019/1/21
         * @params：
         * @description：获取最佳填充条目数
         */
        getFitRows() {
            var rslt = null;
            if (this.fitHeight && this.tableAvailHeight > 0) {
                rslt = Math.floor(this.tableAvailHeight / this.rowHeight);
            }
            this.fitRows = rslt;
            return rslt;
        },
        /**
         * @method：toggleForceTotalflag
         * @createdBy:HuangJian
         * @date:2018/12/17
         * @params：
         * @description：切换强制查询总数的标志
         */
        toggleForceTotalflag(){
            var rqst = this.getQueryRqst();
            if(rqst.data.totalFlag){
                return;
            }
            this.forceTotalflag = !this.forceTotalflag;
            if(this.forceTotalflag){
                this.isTotalForceFetched = false;
                this.fetchRecordCnt((val) => {
                    this.isTotalForceFetched = true;
                    this.total = val;
                });
            }else{
                this.isTotalForceFetched = false;
                this.total = null;
            }

        },
        /**
         * @method：getParentId
         * @createdBy:HuangJian
         * @date:2019/01/02
         * @params：
         * @description：获取头id
         */
        getParentId(params){

            if(!this.parentField){
                return null;
            }

            if(this.parentId){
                return this.parentId;
            }
            if(!params){
                params = this.getQueryRqst(this.page).data || {};
            }

            const test = params[this.parentField];

            if(test && typeOf(test) === 'string' ){
                return test;
            }

            if(params.filtersRaw){
                var filtersRaw = [];
                try {
                    filtersRaw = JSON.parse(params.filtersRaw);
                    for(var i in filtersRaw){
                        var filter = filtersRaw[i];
                        if(filter && filter.property && filter.property === this.parentField){
                            return filter.value;
                        }
                    }
                }catch (e) {}
            }
            return null;
        },
        /**
         * @method：init
         * @param：
         * @description：初始化组件
         */
        init() {
            this.initTools();
            this.initTable();
            this.initDialog();
        },

        /**
         * @method：initTools
         * @param：
         * @description：初始化工具栏
         */
        initTools() {
            var tools = this.$refs.tabletools || {};

            if (tools._isVue) {
                var toolsElButtons = tools.$getChildComponent('ElButton', false);
                toolsElButtons.forEach((button) => {
                    if (hasClass(button.$el, 'shownew')) {
                        this.tools.showNew = button;
                    }
                    if (hasClass(button.$el, 'showclear')) {
                        this.tools.showClear = button;
                    }
                    if (hasClass(button.$el, 'showdel')) {
                        this.tools.showDel = button;
                    }
                    if (hasClass(button.$el, 'showedit')) {
                        this.tools.showEdit = button;
                    }
                });

                /* 插槽tools - 新建*/
                if (this.tools.showNew._isVue) {
                    this.tools.showNew.$on('click', this.showEdit);
                }

                /* 插槽tools - 清空*/
                if (this.tools.showClear._isVue) {
                    this.tools.showClear.$on('click', () => {
                        this.$confirm(
                            this.$t('LnkTableDatapanel.hintClearlist'),
                            this.$t('LnkTableDatapanel.hintTitle'),
                            {type: 'warning'}).then(() => {
                            this.clearData();
                        });
                    });
                }

                /* 插槽tools - 删除*/
                if (this.tools.showDel._isVue) {
                    this.tools.showDel.$on('click', this.showCurrentRowDel);
                }

                /* 插槽tools - 编辑*/
                if (this.tools.showEdit._isVue) {
                    this.tools.showEdit.$on('click', this.showCurrentRowEdit);
                }


                var dropDowns = tools.$getChildComponent('ElDropdown', false);
                dropDowns.forEach((dropdown) => {
                    if (hasClass(dropdown.$el, 'menu-more')) {
                        this.tools.menuMore = dropdown;
                    }
                });

                if (this.tools.menuMore._isVue) {
                    this.tools.menuMore.$on('command', this.handleMoreMenu);
                }
            }


        },

        /**
         * @method：initTable
         * @param：
         * @description：初始化子表格组件
         */
        initTable() {
            var elTable = this.$getChildComponent('ElTable') || {};

            if (!elTable._isVue) return;
            this.elTable = elTable;

            /* 添加监听事件*/
            elTable.$on('sort-change', this.handleSortClick);
            elTable.$on('current-change', () => {
                this.$emit('update:currentrow', this.currentRow);
                this.$emit('update:currentid', this.currentRow && this.currentRow.id || '');
                this.$emit('current-change', this.currentRow);
            });

            /* 排序的默认配置*/
            if (this.elTable.defaultSort) {
                info = this.elTable.defaultSort;
                this.sortConf.sort = info.prop;
                this.sortConf.order = !info.order || info.order === 'ascending' ? 'asc' : 'desc';
            } else if (this.conf.sort) {
                this.sortConf.sort = this.conf.sort.field;
                this.sortConf.order = this.conf.sort.order || 'asc';
            }


            var elTableColumns = elTable.$getChildComponent('ElTableColumn', false) || [];

            /* 供筛选组件使用的组配置信息*/

            var searchOptions = [];
            var searchDefault = null;
            var quickFilterOptions = [];


            /* 初始化列配置*/
            elTableColumns.forEach((column) => {

                /* 索引列*/
                if (column.$attrs.indexing !== undefined
                    && column.$attrs.indexing !== false
                    && column.$attrs.indexing !== 'false') {
                    column.columnConfig.formatter = this.indexMethod;
                    column.columnConfig.label = '';
                }

                if (this.sortAll && column.prop && column.label) {
                    column.columnConfig.sortable = true;
                }

                if (column.label && column.columnConfig.property) {

                    var obj = {
                        field: column.columnConfig.property,
                        name: column.label
                    };

                    /* 值列表*/
                    if (column.$attrs.lov
                        && !column.columnConfig.formatter) {

                        obj.lov = column.$attrs.lov;
                        if (column.$attrs['parent-lov'] && column.$attrs['parent-lov-value']) {
                            obj.parentLov = column.$attrs['parent-lov'];
                            obj.parentLovVal = column.$attrs['parent-lov-value'];
                        }
                        column.columnConfig.formatter = function (row, col, cellValue, index) {
                            return linkLov.getLovShowName(
                                column.$attrs.lov,
                                cellValue
                            );
                        };
                    }

                    /* 自定义类型*/
                    if (['date', 'number'].indexOf(column.$attrs.lnktype) > -1) {
                        obj.type = column.$attrs.lnktype;
                        if (
                            column.$attrs.lnktype === 'date'
                            && column.$attrs['date-format']
                            && !column.columnConfig.formatter) {

                            column.columnConfig.formatter = function (row, col, cellValue, index) {
                                var result = '';
                                try {
                                    if (cellValue && typeof cellValue === 'string') {
                                        result = cellValue.dateFormat(column.$attrs['date-format']);
                                    }
                                } catch (e) {
                                    result = cellValue;
                                }
                                return result;
                            };
                        }
                    }

                    /* 金额类型*/

                    var tmpIndex = ['cny', 'CNY'].indexOf(column.$attrs.lnktype);
                    if (tmpIndex > -1) {
                        delete obj.type;
                        if (tmpIndex < 2) {
                            column.columnConfig.formatter = function (row, col, cellValue, index) {


                                /**
                                 * @method：money_format
                                 * @createdBy：HuangJian
                                 * @date：2018/11/2
                                 * @params：
                                 * number：数字金额
                                 * decimals：小数位数
                                 * dec_point：小数点符号
                                 * thousands_sep：千分位分隔符
                                 * @description：数字金额格式化
                                 *
                                 */

                                const money_format = (number, decimals, dec_point, thousands_sep) => {
                                    number = String(number).replace(/[^0-9+-Ee.]/g, '');
                                    var n = !isFinite(Number(number)) ? 0 : Number(number);
                                    var prec = !isFinite(Number(decimals)) ? 2 : Math.abs(decimals);
                                    var sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
                                    var dec = typeof dec_point === 'undefined' ? '.' : dec_point;
                                    var s = '',
                                        toFixedFix = function (n, prec) {
                                            var k = Math.pow(10, prec);
                                            return String(Math.ceil(n * k) / k);
                                        };

                                    s = (prec ? toFixedFix(n, prec) : String(Math.round(n))).split('.');
                                    var re = /(-?\d+)(\d{3})/;
                                    while (re.test(s[0])) {
                                        s[0] = s[0].replace(re, '$1' + sep + '$2');
                                    }

                                    if ((s[1] || '').length < prec) {
                                        s[1] = s[1] || '';
                                        s[1] += new Array(prec - s[1].length + 1).join('0');
                                    }
                                    return s.join(dec);
                                };

                                var result = cellValue && '?' || '';
                                if (cellValue && !isNaN(cellValue)) {
                                    result = '￥ ' + String(money_format(parseFloat(cellValue), 2));
                                }
                                return result;
                            };
                        }
                    }

                    /* 自定义可选项*/
                    if (Array.isArray(column.$attrs.options)
                        && !column.columnConfig.formatter) {

                        obj.custom = column.$attrs.options;
                        column.columnConfig.formatter = function (row, col, cellValue, index) {
                            var options = column.$attrs.options || [];
                            var result = cellValue;
                            options.forEach((option) => {
                                if (option.val === cellValue) {
                                    result = option.name;
                                }
                            });
                            return result;
                        };
                    }

                    if (column.$attrs['search-default'] !== undefined
                        && column.$attrs['search-default'] !== false
                        && column.$attrs['search-default'] !== 'false') {
                        searchDefault = column.columnConfig.property;
                    }

                    if (column.$attrs['search-disabled'] !== undefined
                        && column.$attrs['search-disabled'] !== false
                        && column.$attrs['search-disabled'] !== 'false') {
                        obj.disabled = true;
                    }

                    /* 添加快速筛选配置*/
                    if (column.$attrs['quick-filter'] !== undefined
                        && column.$attrs['quick-filter'] !== false
                        && column.$attrs['quick-filter'] !== 'false'
                        && (Array.isArray(column.$attrs.options)
                            || column.$attrs.lov)
                    ) {
                        obj.disabled = true;
                        quickFilterOptions.push(obj);
                    }

                    searchOptions.push(obj);
                }

            });

            this.searchOptions = searchOptions;
            this.quickFilterOptions = quickFilterOptions;

            /* 认领下拉选择筛选组件*/
            this.$broadcast('lnk-table-selectfilter', 'setDefaultField', searchDefault);
            this.$broadcast('lnk-table-selectfilter', 'setParentName', this.$getComponentName());
            this.$broadcast('lnk-table-selectfilter', 'setSearchOptions', searchOptions);

            /* 认领快速筛选组件*/
            this.$broadcast('lnk-quickfilter', 'setParentName', this.$getComponentName());
            this.$broadcast('lnk-quickfilter', 'setFilterOptions', quickFilterOptions);

            /* 认领组合查询组件*/
            this.$broadcast('lnk-combinefilter', 'setParentName', this.$getComponentName());
            this.$broadcast('lnk-combinefilter', 'setFilterOptions', searchOptions);
            this.$broadcast('lnk-combinefilter', 'setQueryUrl', this.conf && this.conf.query && this.conf.query.url || '');
        },

        /**
         * @method：handleSortClick
         * @param：
         * column：列名
         * prop：属性
         * order：顺序
         * @description：响应列表的排序
         */
        handleSortClick(info) {
            this.sortConf = {
                sort: info.prop,
                order: !info.order || info.order === 'ascending' ? 'asc' : 'desc'
            };
            if (info.prop === null) {
                if (this.elTable.defaultSort) {
                    info = this.elTable.defaultSort;
                    this.sortConf.sort = info.prop;
                    this.sortConf.order = !info.order || info.order === 'ascending' ? 'asc' : 'desc';
                } else if (this.conf.sort) {
                    this.sortConf.sort = this.conf.sort.field;
                    this.sortConf.order = this.conf.sort.order || 'asc';
                } else {
                    delete this.sortConf.sort;
                    delete this.sortConf.order;
                }
            }
            this.loadRows();
        },


        /**
         * @method：initDialog
         * @param：
         * @description：初始化编辑框
         */
        initDialog() {

            var dialogParent = this.$refs.dlgedit || {};

            var dialog = {};

            /* 获取编辑框句柄*/
            if (dialogParent._isVue) {
                var allDialogs = dialogParent.$getChildComponent('ElDialog', false) || [];
                allDialogs.forEach((subDialog) => {
                    if (hasClass(subDialog.$el, 'rowedit')) {
                        dialog = subDialog;
                    }
                });
            }

            /* 配置编辑框*/
            if (dialog._isVue) {
                this.editDialog = dialog;

                dialog.$on('close', this.hideEdit);

                var dialogElButtons = dialog.$getChildComponent('ElButton', false) || [];
                dialogElButtons.forEach((button) => {

                    if (hasClass(button.$el, 'cancel')) {
                        this.tools.editCancel = button;
                    }
                    if (hasClass(button.$el, 'submit')) {
                        this.tools.editSubmit = button;
                    }
                });

                /* 为底部按钮添加监听*/

                if (this.tools.editCancel._isVue) {
                    this.tools.editCancel.$on('click', this.hideEdit);
                }
                if (this.tools.editSubmit._isVue) {
                    this.tools.editSubmit.$on('click', this.validateEdit);
                }

            }
        },
        /**
         * @method：post
         * @param：
         * rqst：请求参数对象
         * succ：请求成功回调
         * err：请求异常回调
         * @description：针对组件需求封装的请求方法
         * rqst参数说明
         *  rqst：{
         *      url：请求链接
         *      data：请求参数
         *      contentType：报文类型
         *      cancel：请求是否已被取消
         * }
         */
        post(rqst, succ, err) {

            /* 是否取消请求*/
            if (rqst.cancel) {
                return;
            }
            if (!rqst.contentType || rqst.contentType == 'x-www-form-urlencoded') {
                axios1.post(rqst.url, rqst.data).then(succ).
                    catch(err);
            }
            if (rqst.contentType == 'json') {
                axios.post(rqst.url, rqst.data).then(succ).
                    catch(err);
            }
        },

        /**
         * @method：indexMethod
         * @param：
         * @description：表格序号的格式化方法
         */
        indexMethod(row, column, cellValue, index) {
            return (this.page - 1) * this.pageSize + index + 1;
        },

        /**
         * @method：setPage
         * @param：
         * val：页码
         * @description：翻页
         */
        setPage(val) {
            if (typeof val !== 'number') return;
            this.loadRows(val);
        },

        /**
         * @method：setPgSize
         * @param：
         * val：一页的显示个数
         * @description：设置一页的显示个数
         */
        setPgSize(val) {
            if (typeof val !== 'number') return;
            this.pageSize = val;
            this.loadRows(this.page);
        },

        /**
         * @method：setTbData
         * @param：
         * rows：data属性传进来的数据
         * @description：islal为true时，将 rows 传给 tableData 对象，并进行本地筛选
         */
        setTbData(rows) {
            this.tableData = rows;
            this.getFilteredArr();
            this.freshTbRows(this.page);
        },

        /**
         * @method：setCurrentRow
         * @param：
         * row：要设为当前行的数据
         * @description：设置 el-table 显示的当前行
         */
        setCurrentRow(row) {
            if (!row && this.rows && this.rows.length) {
                row = this.rows[0];
            }
            if (this.elTable && typeof this.elTable.setCurrentRow === 'function') {
                this.elTable.setCurrentRow(row);
            }

            row = row || null;

        },

        /**
         * @method：getCurrentRow
         * @param：
         * @description：获取表格的当前行数据
         */
        getCurrentRow() {
            return this.currentRow;
        },

        /**
         * @method：getCurrentIndex
         * @param：
         * @description：获取当前行的索引
         */
        getCurrentIndex() {
            return this.currentIndex;
        },

        /**
         * @method：updatePropData
         * @param：
         * arr：表格里的数据
         * @description：更新data.sync绑定的属性值
         */
        updatePropData(arr) {
            if (typeof arr === 'object' && arr.constructor == Array) {
                this.$emit('update:data', arr);
            } else {
                if (this.islocal) {
                    this.$emit('update:data', this.tableData);
                } else {
                    this.$emit('update:data', this.rows);
                }
            }
        },

        /**
         * @method：clearData
         * @param：
         * @description：清空数据函数
         */
        clearData() {
            var clrconf = null;
            this.conf && this.conf.clear && (clrconf = this.conf.clear);

            if (this.islocal) {
                this.tableData = [];
                this.loadRows();
                this.$message({type: 'success', message: '已清空！', duration: 1500});
            } else {
                if (!clrconf) {
                    this.rows = [];
                    this.page = 1;
                    this.total = 0;
                } else {
                    var rqst = {
                        url: appCtx.ctxPath + clrconf.url ? clrconf.url : '',
                        data: {}
                    };
                    if (clrconf.paraHandler && typeof clrconf.paraHandler === 'function') {
                        clrconf.paraHandler(rqst);
                    }
                    if (this.beforeClear && typeof this.beforeClear === 'function') {
                        this.beforeClear(rqst);
                    }
                    var succHandler = (res) => {
                        if (res.data.success) {
                            this.rows = [];
                            this.page = 1;
                            this.total = 0;
                            this.$message({type: 'success', message: '已清空！', duration: 1500});
                        }
                    };
                    this.post(rqst, succHandler);
                }
            }
            this.updatePropData();
            this.clearShow = false;
        },

        /**
         * @method：loadRowByPara
         * @param：
         * val：查询值
         * field：查询字段
         * condition：查询条件-默认等于
         * @description：自定义单字段查询
         */
        loadRowByPara(val, field, condition) {
            if (!field) {
                this.$message({type: 'error', message: '请传入要查询的feild！', duration: 1000});
                return;
            }
            this.searchFilter = [{id: `${field}_99`, property: field, operator: condition || 'like', value: val || ''}];
            this.loadRows();
        },

        /**
         * @method：loadRows
         * @param：
         * page：页码
         * @description：加载数据
         */
        loadRows(page) {
            if(this.fitHeight && !this.isHeightFited){
                return;
            }
            if (this.islocal) {
                if (this.loadonce && this.isLoadonceValid) {
                    this.queryRows();
                } else {
                    if (typeof page !== 'number') {
                        this.getFilteredArr();
                        page = 1;
                    } else if (page < 1) {
                        page = 1;
                    }
                }

                this.freshTbRows(page);
            } else {
                this.queryRows(page);
            }
        },

        /**
         * @method：freshTbRows
         * @param：
         * val：页码
         * @description：刷新列表，islocal属性为 true 有效
         */
        freshTbRows(val) {
            val = val ? val < 1 ? 1 : val : 1;
            if ((val - 1) * this.pageSize + 1 > this.total) {
                val = Math.ceil(this.total / this.pageSize);
            }
            const base = (val - 1) * this.pageSize;
            const data = this.rowsRef;
            var arr = [];
            for (var i = 0; i < this.pageSize; i++) {
                var tmp = data[base + i];
                if (!tmp) break;
                arr[i] = tmp;
            }
            this.rows = arr;
            this.page = val;
        },

        /**
         * @method：getFilteredArr
         * @param：
         * @description：根据查询条件筛选-本地数据 ，islocal属性为 true 有效
         */
        getFilteredArr() {
            const filters = this.searchFilter;
            const data = this.tableData;

            const filteredData = [];
            const filteredIndexs = [];

            if(!this.localFilter || !Array.isArray(filters) || !filters.length){
                data.forEach((item, index) => {
                    filteredData.push(item);
                    filteredIndexs.push(index);
                });
            }else {
                data.forEach((item, index) => {
                    if(filters.every((filter) => {
                        const operator = (filter.operator || 'like').toLowerCase();
                        const field = filter.property;
                        const keyword = filter.value || '';
                        const value = String(item[field]);
                        switch (operator) {
                            case 'eq':
                            case '=': return value == keyword;
                                break;
                            case 'is null': return !value;
                                break;
                            case 'not null': return Boolean(value);
                                break;
                            case '>': return value>keyword;
                                break;
                            case '<': return value<keyword;
                                break;
                            case '>=': return value>=keyword;
                                break;
                            case '<=': return value<=keyword;
                                break;
                            case 'like':
                            default: return value.indexOf(keyword)>-1;
                                break;
                        }
                        return false;
                    })){
                        filteredData.push(item);
                        filteredIndexs.push(index);
                    }
                });
            }
            this.getLocalmain(this.tableData);
            this.rowsRef = filteredData;
            this.rowsRefIndex = filteredIndexs;
            this.total = filteredData.length;
        },

        /**
         * @method：getQueryRqst
         * @createdBy:HuangJian
         * @date:2018/12/6
         * @params：
         * @description：获取查询的必要信息
         */
        getQueryRqst(page) {
            const queryConfig = this.conf.query || {};

            var rqst = {
                url: appCtx.ctxPath + queryConfig.url,
                data: {},
                contentType: queryConfig.contentType
            };
            const requestPage = page ? page < 1 ? 1 : page : 1;

            var paras = {
                pageFlag: true,
                totalFlag: false,
                page: requestPage,
                rows: this.pageSize
            };

            /* filtersRaw条件*/
            var filtersRaw = [];

            /* 单字段筛选条件*/
            if(Array.isArray(this.searchFilter)){
                filtersRaw = filtersRaw.concat(this.searchFilter);
            }

            /* 自定义参数*/
            if (queryConfig.para) {
                var defaultParams = linkTools.deepCopy(queryConfig.para);
                if (defaultParams.filtersRaw) {
                    if (Array.isArray(defaultParams.filtersRaw)) {
                        filtersRaw = filtersRaw.concat(defaultParams.filtersRaw);
                    } else if (typeof defaultParams.filtersRaw === 'string') {
                        try {
                            var tmpFiltersRaw = JSON.parse(defaultParams.filtersRaw);
                            tmpFiltersRaw = Array.isArray(tmpFiltersRaw) ? tmpFiltersRaw : [];
                            filtersRaw = filtersRaw.concat(tmpFiltersRaw);
                        } catch (e) {
                            linkLog.error(e);
                        }
                    }
                }
                delete defaultParams.filtersRaw;
                linkTools.coverPropsByTpl(paras, defaultParams);
            }

            /* 动态参数*/
            if (this.queryPara && typeof this.queryPara === 'object') {
                var tmpQueryParams = linkTools.deepCopy(this.queryPara);
                if (tmpQueryParams.filtersRaw) {
                    if (Array.isArray(tmpQueryParams.filtersRaw)) {
                        filtersRaw = filtersRaw.concat(tmpQueryParams.filtersRaw);
                    } else if (typeof tmpQueryParams.filtersRaw === 'string') {
                        try {
                            var tmpFiltersRaw = JSON.parse(tmpQueryParams.filtersRaw);
                            tmpFiltersRaw = Array.isArray(tmpFiltersRaw) ? tmpFiltersRaw : [];
                            filtersRaw = filtersRaw.concat(tmpFiltersRaw);
                        } catch (e) {
                            linkLog.error(e);
                        }
                    }
                }
                delete tmpQueryParams.filtersRaw;
                linkTools.coverPropsByTpl(paras, tmpQueryParams);
            }

            /* 来自筛选组件的条件*/
            filtersRaw = filtersRaw.concat(this.quickFilter);
            filtersRaw = filtersRaw.concat(this.combFilter);

            if(this.parentField && this.parentId){
                filtersRaw.push({
                    id: this.parentField+'_11',
                    property: this.parentField,
                    value: this.parentId
                });
            }

            if (filtersRaw.length) {
                paras.filtersRaw = JSON.stringify(filtersRaw);
            }


            /* 安全性配置*/
            if (this.oauth && typeof this.oauth === 'string') {
                paras.oauth = this.oauth;
            }

            /* 排序*/
            if (this.sortConf) {
                linkTools.coverPropsByTpl(paras, this.sortConf);
            }

            linkTools.coverPropsByTpl(rqst.data, paras);
            /* 钩子函数*/

            if (typeof this.beforeQuery === 'function') {
                this.beforeQuery(rqst);
            } else if (typeof queryConfig.paraHandler === 'function') {
                queryConfig.paraHandler(rqst);
            }
            return rqst;
        },
        /**
         * @method：queryRows
         * @param：
         * page：页码
         * @description：根据接口查询数据，islocal属性为 false 有效
         */
        queryRows(page) {

            const queryConfig = this.conf.query || {};

            var rqst = this.getQueryRqst(page);

            const requestPage = page ? page < 1 ? 1 : page : 1;

            /* 校验必传参数*/
            const required = queryConfig.paraRequired;
            var isParamsValid = true;
            if (Array.isArray(required)) {
                for (var i in required) {
                    if (!rqst.data[required[i]]) {
                        isParamsValid = false;
                        break;
                    }
                }
            } else if (typeof required === 'string') {
                isParamsValid = rqst.data[required];
            }

            /* 访问成功回调*/
            const handler = (res) => {

                /* 钩子函数*/
                if (typeof this.afterQuery === 'function') {
                    this.afterQuery({data: res.data});
                } else if (typeof queryConfig.resHandler === 'function') {
                    queryConfig.resHandler(res);
                }

                if (res.data.success) {

                    this.totalFlag = rqst.data.totalFlag;

                    if (this.islocal && this.loadonce && this.isLoadonceValid) {
                        this.tableData = res.data.rows;
                        this.isLoadonceValid = false;
                        this.loadRows();
                        return;
                    }

                    const mainFieldConfig = this.conf.propmain || {};
                    const mainField = mainFieldConfig.field || mainFieldConfig.name;
                    if (mainField && typeof mainField === 'string') {
                        this.getLocalmain(res.data.rows);
                    }

                    this.rows = res.data.rows;
                    this.total = res.data.total;
                    if (this.rows && this.rows.length) {
                        this.$nextTick(() => {
                            if (this.elTable && typeof this.elTable.setCurrentRow === 'function') {
                                this.elTable.setCurrentRow(this.rows[0]);
                            }
                        });
                    }
                    this.page = requestPage;
                    this.updatePropData(this.rows);
                } else {
                    var msg = res.data.result || res.data.message || this.$t('global.unknownError');
                    this.$message({type: 'error', message: msg, duration: 1000});
                }
                this.loading = false;
            };

            /* 访问异常回调*/
            const errHandler = (err) => {
                this.loading = false;
                if (!err.response) {
                    this.$message({type: 'error', message: String(err), duration: 1000});
                }
                if (typeof this.afterQuery === 'function') {
                    this.afterQuery({error: err});
                }
            };

            /* 校验头行结构*/
            if(this.parentField){
                const parentId = this.getParentId(rqst.data);
                if(!parentId){
                    isParamsValid = false;
                }
            }

            if (isParamsValid) {
                this.freshFlag = false;
                if(this.forceTotalflag){
                    rqst.data.totalFlag = true;
                }
                this.loading = true;
                this.lastQueryPara = linkTools.deepCopy(rqst.data);
                // 默认加载后自动查询
                if (!this.conf.defaultNoQuery) {
                    this.post(rqst, handler, errHandler);
                } else {
                    this.loading = false;
                }
            } else {
                this.rows = [];
                this.total = 0;
            }
        },

        /**
         * @method：handleMoreMenu
         * @param：
         * cmd：命令
         * @description：下拉菜单的点击处理
         */
        handleMoreMenu(cmd) {
            switch (cmd) {
                case 'importData':
                    this.handleImport();
                    break;
                case 'exportData':
                    this.exportShow = true;
                    break;
                case 'combfilter':
                    this.combfilterShow = true;
                    break;
                case 'count':
                    this.showRecordCnt();
                    break;
                case 'detail':
                    this.showRecordDetail();
                    break;
                default:
                    this.$emit('menu-click', cmd);
                    break;
            }
        },
        /**
         * @createdBy:HuangJian
         * @date:2018/12/6
         * @method：getImportExportFields
         * @params：
         * cols：所有的列
         * mode: 导出（true）/导入（false）,默认为导出
         * @description：获取导入导出的列配置
         */
        getImportExportFields(cols, mode) {
            if(typeOf(mode)!=='boolean'){
                mode = true;
            }
            if(!Array.isArray(cols)){
                cols = [];
            }
            var result = [];
            const getLovMap = (options) => {
                var obj = {};
                options.forEach((tmp) => {
                    if(mode){
                        obj[tmp.val] = tmp.name;
                    }else{
                        obj[tmp.name] = tmp.val;
                    }
                });
                return obj;
            };
            var order =0;
            cols.forEach((col) => {
                var field = {
                    title: col.name,
                    field: col.field,
                    order: order++
                };
                if (col.lov) {
                    field.lov = col.lov;
                    field.lovMap = getLovMap(col.options);
                }
                if(!mode && this.parentField && this.parentId){
                    field.parentField = this.parentField;
                    field.parentid = this.parentId;
                }
                result.push(field);
            });
            return result;
        },
        /**
         * @method：handleImport
         * @createdBy:HuangJian
         * @date:2018/12/06
         * @params：
         * @description：从文件中导入数据
         */
        handleImport() {
            if(this.parentField && !this.parentId){
                this.$nav.error('页面的主（头）记录为空，不能导入！');
                return;
            }
            var inputTag = document.createElement('input');
            inputTag.type = 'file';
            inputTag.accept = '.csv';

            const uploadHandler = (data) => {
                var fdata = new FormData();

                var importsRaw = this.getImportExportFields(this.fields, false);

                importsRaw = JSON.stringify(importsRaw);


                fdata.append('importsRaw', importsRaw);
                fdata.append('importFile', data);
                fdata.append('importsDefValRaw', JSON.stringify({}));

                const queryUrl = appCtx.ctxPath + (this.conf.query && this.conf.query.url || '');

                const url = this.importUrl || (queryUrl || '').replace(/\/([a-zA-Z0-9])*$/, '/importData');

                axios({
                    url: url,
                    method: 'post',
                    data: fdata,
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((res) => {
                    if (res.data.success) {
                        this.loadRows();
                        this.$message.success(this.$t('LnkTableDatapanel.hintImportSuccess'));
                    } else {
                        this.$nav.error(res.data.result || res.data.message || this.$t('global.unknownError'));
                    }
                }).
                    catch((err) => {
                        this.$nav.error(err);
                    });
            };

            inputTag.onchange = () => {
                const file = inputTag.files && inputTag.files[0];
                const reader = new FileReader();
                const fileData = reader.readAsBinaryString(file);
                uploadHandler(file);
            };
            inputTag.click();
        },

        /**
         * @method：handleExport
         * @createdBy:HuangJian
         * @date:2018/12/6
         * @params：
         * @description：导出数据
         */
        handleExport(exportObj) {

            const fields = exportObj.fields;
            const exportsRaw = this.getImportExportFields(fields);

            var paras = this.getQueryRqst(this.page).data || {};

            paras.exportsRaw = JSON.stringify(exportsRaw);

            if (exportObj.range) {
                paras.exportCurrentPage = exportObj.range === 'all' ? 'N' : 'Y';
            }

            if (exportObj.fileName) {
                paras.exportFileName = exportObj.fileName;
            }

            if (exportObj.fileType) {
                paras.exportFileType = exportObj.fileType;
            }

            const queryUrl = appCtx.ctxPath + (this.conf.query && this.conf.query.url || '');

            const url = this.exportUrl || queryUrl.replace(/\/([a-zA-Z0-9])*$/, '/queryByExamplePage/exportData');

            axios1.post(url, paras).then((resp) => {
                if (resp.data.success) {
                    window.open(resp.data.url);
                } else {
                    this.$nav.error(resp.data.result);
                }
            }).
                catch((error) => {
                    this.$nav.error(error.response.status);
                    linkLog.error(error);
                });

        },

        /**
         * @method：fetchRecordCnt
         * @createdBy:HuangJian
         * @date:2018/12/21
         * @params：
         * @description：获取总数的函数
         */
        fetchRecordCnt(callback){
            if (this.islocal) {
                callback(this.tableData.length);
            } else {
                var rqst = this.getQueryRqst();

                if(this.parentField){
                    const parentId = this.getParentId(rqst.data);
                    if(!parentId){
                        callback(0);
                        return;
                    }
                }


                rqst.data.onlyCountFlag = true;

                const handler = (res) => {
                    if (res.data.success) {
                        callback(res.data.rows[0].total);
                    } else {

                        var msg = res.data.result || res.data.message || this.$t('global.unknownError');
                        this.$message({type: 'error', message: msg, duration: 1000});
                    }
                };

                const errHandler = (err) => {
                    this.$message({type: 'error', message: err, duration: 1000});
                };
                this.post(rqst, handler, errHandler);
            }
        },
        /**
         * @method：showRecordCnt
         * @param：
         * @description：打开记录总数提示框
         */
        showRecordCnt() {
            this.fetchRecordCnt((val) => {
                this.$alert(this.$t('LnkTableDatapanel.hintRecordTotal',{n:val}), this.$t('LnkTableDatapanel.hintTitle'), {});
            });
        },

        /**
         * @method：showRecordDetail
         * @param：
         * @description：打开明细提示框（当前行）
         */
        showRecordDetail() {
            this.recordDetail = [];
            const row = this.currentRow;
            if (this.rows.length < 1) {
                this.$message({type: 'error', message: this.$t('LnkTableDatapanel.hintEmptyTable'), duration: 1000});
                return;
            }
            if (!row) {
                this.$message({type: 'error', message: this.$t('LnkTableDatapanel.hintNoDataSelected'), duration: 1000});
                return;
            }
            this.showDataDetail(row);
        },

        /**
         * @method：showCurrentRowDel
         * @param：
         * @description：打开删除提示框（当前行）
         */
        showCurrentRowDel() {
            if (!this.currentRow) {
                this.$message({type: 'error', message: this.$t('LnkTableDatapanel.hintNoDataSelected'), duration: 1000});
                return;
            }
            this.showDel(this.currentRow, this.currentIndex);
        },

        /**
         * @method：showDel
         * @param：
         * row：要删除的数据
         * index：对应数据的索引
         * @description：打开删除提示框
         */
        showDel(row, index) {
            this.delRow = linkTools.deepCopy(row);
            this.delIndex = index;
            this.$confirm(
                this.$t('LnkTableDatapanel.hintDelete'),
                this.$t('LnkTableDatapanel.hintTitle'),
                {type: 'warning'}).then(() => {
                this.deleteRow();
            });
        },

        /**
         * @method：deleteRow
         * @param：
         * @description：删除数据
         */
        deleteRow() {
            const row = linkTools.deepCopy(this.delRow);
            const rowIndex = this.delIndex;
            if (!row) return;
            if (this.islocal) {
                const index = (this.page - 1) * this.pageSize + rowIndex;
                this.tableData.splice(index, 1);
                this.getFilteredArr();
                var page = this.page;
                if (this.total > this.pageSize) {
                    if (page > 1 && this.rows.length == 1) {
                        page--;
                    }
                }
                this.$message({type: 'success', message: this.$t('LnkTableDatapanel.hintDeleteSuccess'), duration: 1000});
                this.$emit('delete');
                this.freshTbRows(page);
                this.updatePropData(this.tableData);
            } else {
                const dconf = this.conf.del;
                var rqst = {};
                rqst.url = appCtx.ctxPath + dconf.url;
                rqst.contentType = dconf.contentType;
                rqst.data = {id: row.id};
                const handler = (res) => {
                    if (res.data.success) {
                        this.$message({type: 'success', message: this.$t('LnkTableDatapanel.hintDeleteSuccess'), duration: 1000});
                        var page = this.page;
                        const localDel = () => {
                            if (this.optfresh) {
                                this.loadRows(page);
                            } else {
                                this.rows.splice(rowIndex, 1);
                                this.total--;
                                this.updatePropData(this.rows);
                            }
                        };
                        if (this.lastQueryPara && !this.lastQueryPara.pageFlag) {
                            localDel();
                        } else {
                            if (this.rows.length == 1) {
                                if (page > 1) {
                                    page--;
                                    this.loadRows(page);
                                } else {
                                    localDel();
                                }
                            } else if (this.rows.length < this.pageSize) {
                                localDel();
                            } else if (this.total > this.pageSize) {
                                this.loadRows(page);
                            } else {
                                localDel();
                            }
                        }
                        this.$emit('delete');
                    } else {
                        this.$message({type: 'error', message: res.data.result||res.data.message, duration: 1000});
                    }
                };
                const errHandler = (err) => {
                    this.$message({type: 'error', message: String(err), duration: 1000});
                };
                if (dconf.paraHandler && typeof dconf.paraHandler === 'function') {
                    dconf.paraHandler(rqst);
                }
                if (this.beforeDel && typeof this.beforeDel === 'function') {
                    this.beforeDel(rqst);
                }
                this.post(rqst, handler, errHandler);
            }
        },

        /**
         * @method：showCurrentRowEdit
         * @param：
         * @description：打开编辑框（当前行）
         */
        showCurrentRowEdit() {
            if (!this.currentRow) {
                this.$message({type: 'error', message: this.$t('LnkTableDatapanel.hintNoDataSelected'), duration: 1000});
                return;
            }
            this.showEdit(this.currentRow, this.currentIndex);
        },

        /**
         * @method：getEditForm
         * @createdBy:HuangJian
         * @date:2018/12/10
         * @params：
         * @description：获取弹出框 el-form组件引用
         */
        getEditForm(){
            if (this.editDialog && this.editDialog._isVue) {
                return this.editDialog.$getChildComponent('ElForm') || {};
            }
            return {};
        },
        /**
         * @method：
         * @param：
         * row：要编辑的数据
         * index：数据对应的索引
         * @description：打开编辑框
         */
        showEdit(row, index) {
            const initConfig = this.conf.initnew;
            if (this.islocal) {
                var str = String(row);
                this.editMode = Boolean(row && str.indexOf('MouseEvent') === -1);
            } else {
                this.editMode = Boolean(row && row.id);
            }
            var defaultVal = {};
            if (!this.editMode) {
                var p = this.conf.rowDefault;
                if (p) {
                    if (typeof p === 'function') {
                        defaultVal = p();
                    } else {
                        defaultVal = p;
                    }
                } else if (initConfig) {
                    p = initConfig.rowDefault;
                    if (p) {
                        if (typeof p === 'function') {
                            defaultVal = p();
                        } else {
                            defaultVal = p;
                        }
                    }
                }
            }

            defaultVal = defaultVal || {};

            if (!this.editMode && !this.islocal && initConfig && initConfig.url) {
                var rqst = {
                    url: initConfig.url,
                    data: {},
                    contentType: initConfig.contentType
                };
                this.post(rqst, (res) => {
                    if (res.data.success) {
                        var tmp = res.data.result;
                        linkTools.coverPropsByTpl(tmp, defaultVal);
                        this.editFmDt = tmp;
                        this.editIndex = index;
                        this.editShow = true;
                        if (typeof this.beforeEdit === 'function') {
                            this.beforeEdit(this.editFmDt, 'insert');
                        }
                    } else {
                        this.$nav.error(res.data.result || res.data.message || this.$t('global.unknownError'));
                    }
                }, (err) => {
                    this.$nav.error(err);
                });
            } else {
                var tmp = this.editMode ? linkTools.deepCopy(row) : {};
                if (!this.editMode) {
                    linkTools.coverPropsByTpl(tmp, defaultVal);
                }
                this.editIndex = index;
                this.editShow = true;
                if (typeof this.beforeEdit === 'function') {
                    this.beforeEdit(this.editFmDt, this.editMode ? 'update' : 'insert');
                }
                this.$nextTick(() => {
                    const form = this.getEditForm();
                    if(form._isVue){
                        const fields = form.fields;
                        if(!this.editMode && fields.length){
                            fields.forEach((field) => {
                                if(typeOf(tmp[field.prop]) === 'undefined'){
                                    tmp[field.prop] = '';
                                }
                            });
                        }
                        this.editFmDt = tmp;
                        this.$nextTick(() => {
                            form.clearValidate();
                        });
                    }
                });
            }
        },

        /**
         * @method：hideEdit
         * @param：
         * ref：编辑框下 el-form 的ref ,配置 clickMonitor 属性为 true 时可不传
         * @description：隐藏编辑框
         */
        hideEdit() {
            var ref = this.getEditForm();
            if (!ref._isVue || !ref.clearValidate) {
                this.$nav.error('配置错误！');
                return;
            }
            this.editShow = false;
            ref.clearValidate();

        },

        /**
         * @method：validateEdit
         * @param：
         * @description：校验编辑的数据
         */
        validateEdit() {
            const timestamp = new Date().getTime();

            if(this.lastValideTime){
                if(timestamp - this.lastValideTime <= 500){
                    this.lastValideTime = timestamp;
                    return;
                }
            }

            this.lastValideTime = timestamp;

            var ref = this.getEditForm();

            if (!ref._isVue || !ref.validate) {
                this.$nav.error('配置错误！');
                return;
            }
            var isValid = false;

            ref.validate((valid) => {
                isValid = valid;
            });

            if (!isValid) {
                this.$nav.error('还有必输的信息没填或不符合要求！');
            } else {
                ref.clearValidate();
                this.submitEdit();
            }
        },

        /**
         * @method：submitEditByPara
         * @param：
         * row：要保存的数据
         * index：数据对应的索引
         * mode：是否为编辑操作
         * callback：请求回调
         * @description：自定义数据的保存方法
         */
        submitEditByPara(row, index, mode, callback) {
            this.editFmDt = linkTools.deepCopy(row);
            this.editIndex = index;
            this.editMode = mode;
            this.submitEdit(callback);
        },

        /**
         * @method：submitEdit
         * @param：
         * callback：请求回调
         * @description：提交编辑框里的数据
         */
        submitEdit(callback) {

            const config = this.conf || {};

            const rowIndex = this.editIndex;

            var row = linkTools.deepCopy(this.editFmDt);

            if (this.islocal) {
                if(this.isSaving) return;
                this.isSaving = true;
                if (this.editMode) {
                    linkTools.coverPropsByTpl(this.rows[rowIndex], row);
                    this.loadRows(this.page);
                } else {
                    this.tableData.splice(0, 0, row);
                    this.loadRows();
                    this.updatePropData(this.tableData);
                }
                this.editShow = false;
                this.isSaving = false;
            } else {

                if(this.isSaving) return;
                this.isSaving = true;

                var rqst = null;

                /* 请求配置是否就绪*/
                var isRequestReady = false;

                var paras = row || {};

                /* 加载upsert接口配置*/
                if (config.upsert && typeof config.upsert.url === 'string') {

                    rqst = {
                        url: appCtx.ctxPath + config.upsert.url,
                        contentType: config.upsert.contentType
                    };

                    linkTools.coverPropsByTpl(rqst.data, config.upsert.para);

                    paras.row_status = this.editMode ? 'UPDATE' : 'NEW';

                    if (typeof config.upsert.paraHandler === 'function') {
                        config.upsert.paraHandler(rqst);
                    }
                    isRequestReady = true;
                }


                if (!isRequestReady) {

                    /* 加载insert\update接口配置*/
                    if (this.editMode && config.update) {
                        rqst = {
                            url: appCtx.ctxPath + config.update.url,
                            contentType: config.update.contentType
                        };

                        linkTools.coverPropsByTpl(paras, config.update.para);
                        if (typeof config.update.paraHandler === 'function') {
                            config.update.paraHandler(rqst);
                        }
                        isRequestReady = true;
                    } else if (config.insert) {
                        rqst = {
                            url: appCtx.ctxPath + config.insert.url,
                            contentType: config.insert.contentType
                        };

                        linkTools.coverPropsByTpl(paras, config.insert.para);

                        if (typeof config.insert.paraHandler === 'function') {
                            config.insert.paraHandler(rqst);
                        }
                        isRequestReady = true;
                    }
                }

                if (!isRequestReady) {
                    this.$nav.error('请配置相关的后台接口！');
                    return;
                }

                const typeStr = this.editMode ? 'update' : 'insert';

                /* 加载默认参数*/
                if (config.upsert && this.upsertPara) {
                    linkTools.coverPropsByTpl(paras, this.upsertPara);
                } else if (this.editMode && config.update && this.updatePara) {
                    linkTools.coverPropsByTpl(paras, this.updatePara);
                } else if (config.insert && this.insertPara) {
                    linkTools.coverPropsByTpl(paras, this.insertPara);
                }

                rqst.data = paras;

                if (typeof this.beforeUpsert === 'function') {
                    this.beforeUpsert(typeStr, rqst);
                }

                const handler = (res) => {

                    if (typeof this.afterUpsert === 'function') {
                        this.afterUpsert(typeStr, {data: res.data});
                    }

                    /* 自定义保存方法的回调*/
                    if (typeof callback === 'function') {
                        callback(res);
                    }

                    /* 接口调用成功*/
                    if (res.data.success) {

                        this.editShow = false;
                        var newrow = res.data.newRow;

                        /* 响应主要字段配置*/
                        const mainFieldConfig = config.propmain || {};
                        const mainField = mainFieldConfig.field || mainFieldConfig.name;

                        /* 更新主要字段*/
                        if (mainField
                            && typeof mainField === 'string'
                            && row[mainField] == 'Y') {
                            this.submitPropmain(newrow);
                        }

                        /* 强制刷新列表*/
                        if (this.optfresh) {
                            this.loadRows(this.page);
                        } else {

                            /* 更新表中数据*/
                            if (this.editMode) {
                                this.rows.splice(rowIndex, 1, newrow);
                            } else {
                                this.rows.splice(0, 0, newrow);
                                if (this.rows.length > this.pageSize) {
                                    this.rows.splice(this.rows.length - 1, 1);
                                }
                                this.total++;
                            }
                        }

                        /* 更新data属性*/
                        this.updatePropData(this.rows);

                        const msg = this.editMode ? '保存成功！' : '新建成功！';

                        this.$message({type: 'success', message: msg});
                    } else {

                        var msg = res.data.result || res.data.message || this.$t('global.unknownError');
                        this.$message({type: 'error', message: msg, duration: 1000});
                    }

                    this.isSaving = false;

                };

                const errHandler = (err) => {

                    this.isSaving = false;

                    if (typeof callback === 'function') {
                        callback(err);
                    }
                    if (!err.response) {
                        this.$message({type: 'error', message: '服务器连接异常！', duration: 1000});
                    }

                    if (typeof this.afterUpsert === 'function') {
                        this.afterUpsert(typeStr, {error: err});
                    }
                };


                this.post(rqst, handler, errHandler);
            }
        },

        /**
         * @method：submitPropmain
         * @param：
         * row：要设为主要记录的数据
         * notsync：是否 不更新外部属性 mainid 的值
         * @description：更新主要记录
         */
        submitPropmain(row, notsync) {

            const mainFieldConfig = this.conf.propmain || {};
            const mainField = mainFieldConfig.field || mainFieldConfig.name;
            if (!mainField || !row || !row.id) return;

            if (this.islocal) {
                this.setLocalmain(row);
                if (!notsync) this.$emit('update:mainid', this.mainRow ? this.mainRow.id : null);
            } else {
                var rqst = {
                    url: appCtx.ctxPath + mainFieldConfig.url,
                    contentType: mainFieldConfig.contentType,
                    data: {}
                };

                var paras = {};

                /* 加载参数模板*/
                if (mainFieldConfig.tpl) {
                    paras[mainFieldConfig.tpl.rowid] = row.id;
                    paras[mainFieldConfig.tpl.relateid] = this.mainRelateid;
                }

                if (this.upmainPara && typeof this.upmainPara === 'object') {
                    linkTools.coverPropsByTpl(paras, this.upmainPara);
                }

                linkTools.coverPropsByTpl(rqst.data, paras);

                const handler = (res) => {
                    if (res.data.success) {
                        this.setLocalmain(row);
                        if (!notsync) this.$emit('update:mainid', this.mainRow ? this.mainRow.id : null);
                    } else {
                        this.$nav.error(res.data.result || res.data.message || this.$t('global.unknownError'));
                    }
                };

                const errHandler = (err) => {
                    this.$nav.error(err);
                };

                if (typeof this.beforeUpmain === 'function') {
                    this.beforeUpmain(rqst, row);
                }

                if (typeof mainFieldConfig.paraHandler === 'function') {
                    mainFieldConfig.paraHandler(rqst, row);
                }
                this.post(rqst, handler, errHandler);
            }

        },

        /**
         * @method：setLocalmain
         * @param：
         * row：主要行的数据
         * @description：刷新本地数据的主要标志
         */
        setLocalmain(row) {
            const mainFieldConfig = this.conf.propmain || {};
            const mainField = mainFieldConfig.field || mainFieldConfig.name;
            if (!mainField) return;

            const arr = linkTools.deepCopy(this.islocal ? this.tableData : this.rows);

            arr.forEach((obj) => {
                if (obj.id == row.id) {
                    this.mainRow = linkTools.deepCopy(obj);
                    obj[mainField] = 'Y';
                } else {
                    obj[mainField] = 'N';
                }
            });

            if (this.islocal) {
                this.tableData = arr;
                this.freshTbRows(this.page);
            } else {
                this.rows = arr;
            }
        },

        /**
         * @method：getLocalmain
         * @param：
         * arr：表格里能显示的所有数据
         * @description：遍历本地数据并获取主要记录
         */
        getLocalmain(arr) {
            const mainFieldConfig = this.conf.propmain || {};
            const mainField = mainFieldConfig.field || mainFieldConfig.name;
            if (!mainField || !Array.isArray(arr)) return;

            var mainRow = {id: null};

            arr.forEach((obj) => {
                if (obj[mainField] === 'Y') {
                    mainRow = linkTools.deepCopy(obj);
                }
            });

            this.mainRow = mainRow;
        },

        /**
         * @method：chkRepeat
         * @param：
         * row：要校验的数据
         * props：要校验的属性,Array
         * ignoreIndex：要忽略的行索引
         * @description：根据给定的属性校验本地数据的唯一性
         */
        chkRepeat(row, props, ignoreIndex) {
            const data = this.islocal ? this.tableData : this.rows;
            if(!Array.isArray(props)){
                props = [props];
            }
            const sindex = data.findIndex((item) => {
                if(this.rows[ignoreIndex] === item) return false;
                return props.every((prop) => item[prop] === row[prop]);
            });
            return sindex>-1;
        },

        /**
         * @method：replace
         * @param：
         * index：要替换数据的索引
         * row：要替换的数据
         * @description：替换某一行的数据
         */
        replace(index, row) {
            if (row && typeof row === 'object' && index >= 0) {
                linkTools.coverPropsByTpl(this.rows[index], row);
                if (this.islocal) {
                    this.updatePropData(this.tableData);
                } else {
                    this.updatePropData(this.rows);
                }

            } else {
                this.$nav.error('参数错误！');
            }
        },

        /**
         * @method：fresh
         * @param：
         *  page：页码
         * @description：刷新表格，组件外部调用
         */
        fresh(page) {
            this.loadRows(typeof page === 'number' ? page : this.page);
        }
    }
};
